import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = { class: "w-full md:w-9/12" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 px-4" }
const _hoisted_5 = { class: "w-full md:w-9/12" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-y-4 gap-x-6 px-4" }
const _hoisted_7 = { class: "w-full md:w-9/12" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 px-4" }
const _hoisted_9 = { class: "w-full md:w-9/12" }
const _hoisted_10 = { class: "grid grid-cols-1 gap-x-6 px-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Status Harga ", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500 max-w-md my-1" }, " Klik tombol dibawah untuk mengubah pengaturan harga ", -1)
const _hoisted_13 = { class: "flex flex-row my-3 text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_15 = { class: "ml-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: "RTSHQ Penalty",
      "custom-class": "px-0",
      "leave-page-confirmation": _ctx.leavePageConfirmation,
      "onUpdate:leave-page-confirmation": _cache[7] || (_cache[7] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
      onLeavePage: _ctx.onLeavePage,
      loading: _ctx.isLoading,
      error: !!_ctx.errorCause,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetail
    }, {
      "top-right": _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_lp_button, {
            "text-color": "white",
            customClass: "w-full py-2.5",
            title: "Simpan",
            onClick: _ctx.onSaveForm,
            disabled: !_ctx.isFormValid
          }, null, 8, ["onClick", "disabled"])
        ])
      ]),
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_DataWrapper, {
                label: "ID Konfigurasi",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    disabled: "",
                    disableBackground: "",
                    modelValue: _ctx.form.configurablePriceId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.configurablePriceId = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "Nama Konfigurasi Biaya",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    disabled: "",
                    disableBackground: "",
                    modelValue: _ctx.form.configurablePriceName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.configurablePriceName = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_DataWrapper, {
                label: "Deskripsi Konfigurasi",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    type: "textarea",
                    textAreaRows: "3",
                    modelValue: _ctx.form.configurablePriceDescription,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.configurablePriceDescription = $event)),
                    maxLength: "220",
                    minLength: "3"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_DataWrapper, {
                label: "Tipe Tarif",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomDropdown, {
                    options: _ctx.tariffs,
                    selectedItem: _ctx.form.configurableRtshqPenalty.crpRateType,
                    "onUpdate:selectedItem": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.configurableRtshqPenalty.crpRateType = $event)),
                    placeholder: "Pilih Tipe Tarif",
                    class: "my-1.5",
                    expandUpwards: true
                  }, null, 8, ["options", "selectedItem"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "Persentase Denda Penalti",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    format: _ctx.formatFloat,
                    modelValue: _ctx.form.configurableRtshqPenalty.crpPercentage,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.configurableRtshqPenalty.crpPercentage = $event)),
                    onChange: _ctx.validatePercentagePenalty,
                    error: _ctx.error.percentagePenalty.error,
                    errorCaption: _ctx.error.percentagePenalty.errorCaption,
                    suffix: "%"
                  }, null, 8, ["format", "modelValue", "onChange", "error", "errorCaption"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createVNode("div", _hoisted_13, [
                _createVNode("div", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openStatusConfirmation && _ctx.openStatusConfirmation(...args))),
                  class: 
                      `toggle-switch inline-block cursor-pointer ${
                        _ctx.statusToggle ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                      }`
                    
                }, [
                  _hoisted_14
                ], 2),
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.statusToggle ? "Aktif" : "Tidak Aktif"), 1)
              ])
            ])
          ])
        ])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_DataWrapper, { label: "Status Konfigurasi Biaya" }, {
          default: _withCtx(() => [
            _createVNode(_component_ChipsV2, {
              label: _ctx.form.configurablePriceStatus,
              class: "mt-2"
            }, null, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Tanggal Dibuat",
          value: _ctx.convertCreatedAt,
          caption: _ctx.form.configurablePriceCreatedBy
        }, null, 8, ["value", "caption"]),
        _createVNode(_component_DataWrapper, {
          label: "Terakhir Diperbarui",
          value: _ctx.convertUpdatedAt,
          caption: _ctx.form.configurablePriceUpdatedBy
        }, null, 8, ["value", "caption"])
      ]),
      _: 1
    }, 8, ["onBack", "leave-page-confirmation", "onLeavePage", "loading", "error", "errorType", "onTryAgain"]),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCancelStatusToggle,
      onSubmit: _ctx.onSubmitStatusToggle,
      title: _ctx.dialogToggle.title,
      message: _ctx.dialogToggle.message,
      image: _ctx.dialogToggle.icon,
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit", "title", "message", "image"]), [
      [_vShow, _ctx.openDialogStatusToggle]
    ])
  ], 64))
}